module.exports = __webpack_public_path__ + "img/sensor-blue.0b3250be.svg";